<template>
  <div>
    <DataTable
      data-test-id="fitTestHistory"
      :edit-button-title="t('buttons.viewDetails')"
      :search-type="SearchType.Query"
      :title="title"
      :table-store-id="TableStoreId.FitTests"
      class="expanded-row"
      :no-data-text="t('text.noTestsPerformed')"
      :show-delete="false"
      :show-new="false"
    >
      <template v-slot:item.overallPass="{ item }">
        <FitTestStatus v-model="item.overallPass" />
      </template>
    </DataTable>
  </div>
</template>

<script setup lang="ts">
// STORES, IMPORTS, & COMPOSABLES
import { SearchType } from '@/enums/SearchType'
import { TableStoreId } from '@/enums/TableStoreId'
import type { IFitTestsStore } from '@/interfaces/api/IFitTestsStore'
import { TableStoreFactory } from '@/stores/db/TableStoreFactory'
import { computed, onBeforeMount } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n({ useScope: 'global' })
const fitTestStore = TableStoreFactory.get(TableStoreId.FitTests) as IFitTestsStore

// PROPS & EMITS
const props = defineProps({
  person: { type: Object, required: true }
})

// REACTIVE VARIABLES

// COMPUTED PROPERTIES
const title = computed(() => {
  return `${t('headers.fitTestHistory')}: ${props.person.firstName} ${props.person.lastName} (${props.person.idNumber})`
})

// LIFECYCLE HOOKS
onBeforeMount(async () => {
  fitTestStore.updateHeaders()
})

// FUNCTIONS
</script>
